<template>
    <div
        class="c-title"
    >{{ text }}</div>
</template>

<script>
export default {
    props: {
        text: {type: String, default: null}
    }
}
</script>

<style lang="scss">
.c-title {
    font-size: 15px;
    color: rgba(0, 0, 0, 0.87);
}
</style>